export const REMOVE_COUPON_REQUEST = 'REMOVE_COUPON_REQUEST'
export const REMOVE_COUPON_SUCCESS = 'REMOVE_COUPON_SUCCESS'
export const REMOVE_COUPON_FALIURE = 'REMOVE_COUPON_FALIURE'
